import Audit from './index';
import Deposit from './NewDeposit';
import Withdrawal from './Withdrawal';
import TransferStation from './TransferStation';
import KYC from './KYC';
import KYCSet from './KYCSet';
import RealnameSwitch from './RealnameSwitch';
import OTC from './OTC';
import MerchantRecordList from './OTC/components/MerchantRecordList/index.vue';
import OtcPayeeList from './OTC/components/OtcPayeeList/index.vue';
import OtcUpgradeList from './OTC/components/OtcUpgradeList/index.vue';
import AdAudit from './OTC/components/AdAudit/index.vue';
import OtcOrder from './OTC/components/OtcOrder/index.vue';
import orderAppeal from './OTC/components/orderAppeal/index.vue';
import orderAppeal2 from './OTC/components/orderAppeal2/index.vue';
import OtcMerchantList from './OTC/components/otcMerchantList/index.vue';
import freeze from './OTC/components/freeze/index.vue';
import C2C from './C2C';
import Tribe from './Tribe';
import DepositManual from './DepositManual';
import DepositCheck from './DepositCheck';
import ManualAuditConfig from './manualAuditConfig';
import EnterAccount from './enterAccount';
import DepositLimit from './DepositLimit';
import HotCoin from './hotCoin.vue';
import withdrawInfo from './WithdrawInfo/index.vue';
import DataStatistic from './NewDeposit/components/statistic';
import Automatic from './Automatic';
import WithdrawalSetting from './withdrawalSetting/index.vue'
import Widthraws from './'
export default {
    path: '/home/audit',
    component: Audit,
    children: [
        { path: '/home/audit/Deposit', component: Deposit },
        { path: '/home/audit/statistic', component: DataStatistic },
        { path: '/home/Limit', component: DepositLimit },
        { path: '/home/audit/withdrawal', component: Withdrawal },
        { path: '/home/audit/transferStation', component: TransferStation },
        { path: '/home/audit/kyc', component: KYC },
        { path: '/home/audit/kycset', component: KYCSet },
        { path: '/home/audit/realnameSwitch', component: RealnameSwitch },
        {
            path: '/home/audit/otc',
            component: OTC,
            children: [{
                    path: '/home/audit/otc/MerchantRecordList',
                    component: MerchantRecordList
                },
                { path: '/home/audit/otc/OtcPayeeList', component: OtcPayeeList },
                { path: '/home/audit/otc/OtcUpgradeList', component: OtcUpgradeList },
                { path: '/home/audit/otc/AdAudit', component: AdAudit },
                { path: '/home/audit/otc/OtcOrder', component: OtcOrder },
                { path: '/home/audit/otc/freeze', component: freeze },
                { path: '/home/audit/otc/orderAppeal', component: orderAppeal },
                { path: '/home/audit/otc/orderAppeal2', component: orderAppeal2 },
                { path: '/home/audit/otc/otcMerchantList', component: OtcMerchantList }
            ]
        },
        { path: '/home/audit/setting', component: WithdrawalSetting },
        { path: '/home/audit/config', component: ManualAuditConfig },
        { path: '/home/audit/enter/account', component: EnterAccount },
        { path: '/home/audit/C2C', component: C2C },
        { path: '/home/audit/tribe', component: Tribe },
        { path: '/home/audit/DepositManual', component: DepositManual },
        { path: '/home/audit/DepositCheck', component: DepositCheck },
        { path: '/home/audit/hotCoin', component: HotCoin },
        { path: '/home/audit/withdrawInfo', component: withdrawInfo },
        { path: '/home/audit/automatic', component: Automatic }
    ]
};